import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "operamind_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});


export const VAPI_PUBLIC_KEY = process.env.REACT_APP_VAPI_PUBLIC_KEY || "";
export const VAPI_ASSISTANT_ID = process.env.REACT_APP_VAPI_ASSISTANT_ID || "";
export const vapiEnabled = Boolean(VAPI_PUBLIC_KEY && VAPI_ASSISTANT_ID);
